export default {"src":"/_next/static/media/user.4b2bfb17.svg","height":20,"width":20};